<template>
  <div>
    <div class="bus-schedule mb-8" v-for="(schedule, index) in schedules" v-show="schedule.rows.length">
      <p class="font-semibold" v-if="schedules.length > 1">Bus {{ index + 1 }}</p>
      <div class="table striped hovered main-first-cell">

        <div class="thead w-full">
          <div class="tr">
            <div class="td"><i class="mt-1 ml-1 fas fa-bus"></i></div>
            <div class="td">Haltestelle</div>
            <div class="td" v-for="(column, index) in schedule.titleRow" v-if="index > 1"></div>
          </div>
        </div>

        <div class="tbody">
          <div v-if="row[0]" class="tr" v-for="(row, index) in schedule.rows">
            <div class="td" v-for="(column, index) in row" :class="{'font-semibold': index === 0}">{{ column }}</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'ihk-bus-schedule',

        props: {
            fileUrls: {
                default: null,
                type: Array,
            }
        },

        created() {
            this.fileUrls.forEach(fileUrl => {
                this.$papa.parse(fileUrl, {
                    download: true,
                    encoding: 'utf-8',
                    complete: this.handleCsvFile
                });
            });
        },

        data() {
            return {
                schedules: []
            }
        },

        methods: {
            handleCsvFile(res) {
                console.log(res);
                let titleRow = res.data[0];
                res.data.shift(); // Remove first row
                let rows = res.data;

                this.schedules.push({
                    titleRow,
                    rows
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
  $black: #22292f;
  $grey-darkest: #2890c8;
  $grey-darker: #606f7b;
  $grey-dark: #8795a1;
  $grey: #b8c2cc;
  $grey-light: #dae1e7;
  $grey-lighter: #f1f5f8;
  $grey-lightest: #e6e8ea;
  $white: #f5f5f5;

  $thead-bg-color: $grey-darkest;
  $thead-text-color: $grey-lighter;
  $td-bg-color: $grey-lightest;
  $td-bg-alt-color: $white;
  $td-hover-color: $grey-lighter;

  .bus-schedule {
    overflow: auto;

    .table {
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      font-size: 0.875rem;
      line-height: 1.5;

      &.main-first-cell {
        .tr {
          .td {
            flex-grow: 1;
            flex: none;
            width: 65px;
            text-align: center;
            justify-content: center;
            border: 1px solid rgba(177, 177, 177, 0.18);
            color: #373737;

            &:nth-child(1) {
              max-width: 42px;
            }

            &:nth-child(2) {
              flex-grow: 2;
              text-align: left;
              justify-content: flex-start;
              min-width: 120px;
              max-width: 200px;
            }
          }
        }
      }

      &.striped {
        .tbody {
          border-top: none;

          .tr {
            &:nth-of-type(even) {
              .td {
                background-color: $td-bg-alt-color;
              }
            }
          }
        }
      }

      .thead {
        font-weight: 700;

        .tr {
          .td {
            color: $thead-text-color;
            background-color: $thead-bg-color;
            text-transform: uppercase;
            border-color: $thead-bg-color;

            &:first-child {
              border-radius: 5px 0px 0px 0px;
            }

            &:last-child {
              border-radius: 0px 5px 0px 0px;
            }
          }
        }
      }

      .tbody {
        .tr {
          .td {
            background-color: $td-bg-color;
          }
        }
      }

      .tr {
        display: flex;
        flex-flow: row nowrap;

        .td {
          display: flex;
          flex-flow: row nowrap;
          flex-grow: 1;
          flex-basis: 0;
          word-break: break-word;
          padding: 6px;
        }
      }
    }
  }
</style>
